export default "__VITE_ASSET__a10736a7__"